import { render, staticRenderFns } from "./voterRegistration.vue?vue&type=template&id=2ea7988a"
import script from "./voterRegistration.vue?vue&type=script&lang=js"
export * from "./voterRegistration.vue?vue&type=script&lang=js"
import style0 from "./voterRegistration.vue?vue&type=style&index=0&id=2ea7988a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports